import { render } from "./Messages-tab.vue?vue&type=template&id=bf59a018&scoped=true"
import script from "./Messages-tab.vue?vue&type=script&lang=js"
export * from "./Messages-tab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=bf59a018&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf59a018"]])

export default __exports__